<!-- 办公用品 -->
<template>
  <div class='page_content'>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :flagList="['osmActivestatus']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch">
          <template slot="searchInput" slot-scope="{formOneValue}">
            <el-select size="mini" class="form_codition" v-if="formOneValue.fieldType == 'formatter'" clearable v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
              <el-option v-for="(item, index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </template>
        </v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
          :min-width="tableValye.fieldWeight" v-if="tableValye.isShow == 1">
          <template slot-scope="scope">
            <span v-if="tableValye.entityField == 'createTime'">
              {{ $common.getLocalTime(scope.row.createTime) }}
            </span>
            <span v-else-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
            </span>
            <el-tag v-else-if="tableValye.entityField == 'osmActivestatus'" size="mini">
              {{ $common.getIsGsp(tableValye.formatterContent, scope.row.osmActivestatus) }}</el-tag>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

    </div>

    <!-- 数据操作窗口 -->
    <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" custom-class="drawer_box" :direction="dataActionBox.openMode" size="50%">
      <div class="demo-drawer__content data_action_form">
        <div class='data_page_content'>
          <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
              <template slot="tabs" slot-scope="scope">
                <div v-if="scope.index == 0">
                  <el-form class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :show-message="false" :rules="rules">
                    <el-row>
                      <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" :required="formOneValue.isRequired == 1">
                        <!-- 状态 -->
                        <template v-if="formOneValue.isShow == 1">
                          <el-select size="mini" v-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                          </el-select>
                          <!-- 备注 -->
                          <el-input v-else-if="formOneValue.entityField == 'osmRemarks'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                          <!-- 条码 /名称 /助记码 /生产商 /产地 /规格 -->
                          <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                        </template>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
                <div v-if="scope.index == 1">
                  <el-form label-width="100px" :inline="true">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <template v-if="formOneValue.isShow == 1">
                          <!-- 系统字段 -->
                          <div v-if="formOneValue.isReserved == 0">
                            <!-- 进项税率 -->
                            <el-input v-if="formOneValue.entityField == 'inRate'" v-model="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">%</template>
                            </el-input>
                            <!-- 销项税率 -->
                            <el-input v-else-if="formOneValue.entityField == 'outRate'" v-model="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">%</template>
                            </el-input>
                            <!-- 税务分类名称/税务分类编码 -->
                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                          </div>

                          <!-- 扩展字段 -->
                          <div v-if="formOneValue.isReserved == 1">
                            <!-- 自填 -->
                            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength">
                            </el-input>
                            <!-- 选择数据来源 -->
                            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" :disabled="dataActionBox.actionType == 1 && formOneValue.modifyChange == 0 ? true : false"
                              @focus="$refs['showSelectData'].openBox(formOneValue.dsmName, formOneValue.entityField, formOneValue.dsmField)">
                            </el-input>
                          </div>

                        </template>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
                <div v-if="scope.index == 2">
                  <el-form label-width="100px" :inline="true">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <template v-if="formOneValue.isShow == 1">
                          <!-- 系统字段 -->
                          <div v-if="formOneValue.isReserved == 0">
                            <!-- {{formOneValue.entityField}} -->
                            <!-- 长 -->
                            <el-input v-if="formOneValue.entityField == 'ospMinilength'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">米（m）</template>
                            </el-input>

                            <!-- 宽 -->
                            <el-input v-else-if="formOneValue.entityField == 'ospMiniwidth'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">米（m）</template>
                            </el-input>

                            <!-- 高 -->
                            <el-input v-else-if="formOneValue.entityField == 'ospMiniheight'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">米（m）</template>
                            </el-input>

                            <!-- 体积 -->
                            <el-input v-else-if="formOneValue.entityField == 'ospMinivolume'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">立方米（m³）</template>
                            </el-input>

                            <!-- 重量 -->
                            <el-input v-else-if="formOneValue.entityField == 'ospMiniweight'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" max="100" min="0">
                              <template slot="append">千克（kg）</template>
                            </el-input>

                            <!-- 包装情况/计量单位/颜色 -->
                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                          </div>

                          <!-- 扩展字段 -->
                          <div v-if="formOneValue.isReserved == 1">
                            <!-- 自填 -->
                            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength">
                            </el-input>
                            <!-- 选择数据来源 -->
                            <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" :disabled="dataActionBox.actionType == 1 && formOneValue.modifyChange == 0 ? true : false"
                              @focus="$refs['showSelectData'].openBox(formOneValue.dsmName, formOneValue.entityField, formOneValue.dsmField)">
                            </el-input>
                          </div>
                        </template>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </template>
            </v-tabs>
          </el-card>
          <div class="foots">
            <el-button @click="initActionBox">取消</el-button>
            <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存
            </el-button>
            <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存
            </el-button>
          </div>
        </div>

      </div>

    </el-drawer>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        osmName: '',
        osmActivestatus: '',
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: []
      },

      buttonList: [],
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      showTabs: '办公用品表单',
      sendDataInfo: {
        "osmActivestatus": "", // 启用状态，启用状态（从字典选择：正常、停止采购、停止销售、停用）
        "osmBarcode": "", // 条码
        "osmCreater": '', // 创建人
        "manufacturer": "", // 	生产商
        "osmMnemonic": "", // 助记码
        "osmName": "", // 名称
        "placeorigin": "", // 产地
        "osmRemarks": "", // 备注
        "spec": "", // 规格

        "osmReserves1": "", // 预留字段1
        "osmReserves2": "", // 预留字段2
        "osmReserves3": "", // 预留字段3
        "osmReserves4": "", // 预留字段4
        "osmReserves5": "", // 预留字段5
        "osmReserves6": "", // 预留字段6

        "inRate": "", // 进项税率
        "outRate": "", // 销项税率
        "osfTaxname": "", // 税务分类名称
        "osfTaxnumber": "", // 税务分类编码

        "osfReserves1": "", // 预留字段1
        "osfReserves2": "", // 预留字段2
        "osfReserves3": "", // 预留字段3
        "osfReserves4": "", // 预留字段4
        "osfReserves5": "", // 预留字段5
        "osfReserves6": "", // 预留字段6

        "ospColor": "", // 颜色
        "ospMiniheight": "", // 高度
        "ospMinilength": "", // 长度
        "ospMinivolume": "", // 体积
        "ospMiniweight": "", // 重量
        "ospMiniwidth": "", // 宽度
        "ospSituation": "", // 包装情况		         
        "ospUnitmeasurement": "", // 	计量单位		          
        "ospReserves1": "", // 预留字段1
        "ospReserves2": "", // 预留字段2
        "ospReserves3": "", // 预留字段3
        "ospReserves4": "", // 预留字段4
        "ospReserves5": "", // 预留字段5
        "ospReserves6": "", // 预留字段6

      },
      selectedDataIndex: 0, //当前操作索引
      rules: {
        osmName: [{
          required: true,
          message: '请输入名称',
          trigger: 'change'
        }],
      },
      pageShowData: [],
      formField: [],
      sendComponetsAttribute: '',
      tabForm: [],
      mxForm: [],
      footForm: [],
      seTitle: "",
      seWidth: "",
      seId: "",
      sField: "",
      DialogVisible: false,
      parentSearchData: {},

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.osmName"() {
      this.sendDataInfo.osmMnemonic = this.$common.createPinyinCode(this.sendDataInfo.osmName,this.sendDataInfo.osmMnemonic)
    },
  },
  //方法集合
  methods: {
    getSeWidth(e) {
      console.log(e);
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      this.seTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    // 子组件触发
    drawerCancel() {
      this.showStatus = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1
        this.getRequestData.end = time
      }
    },
    isShowData(name, value) {
      this.sendDataInfo[name] = value
      console.log(name)
      console.log(value)
      // this.sendDataInfo[] = data
      // pageShowData[]
    },

    // 获取数据详情--修改
    getDataDateils() {
      var olddataInfo = this.returnData.list[this.selectedDataIndex]
      if (!olddataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }

      let dataInfo = JSON.parse(JSON.stringify(olddataInfo))
      let dempOfsuppliesfinance = olddataInfo.dempOfsuppliesfinance
      let dempOfsuppliespacking = olddataInfo.dempOfsuppliespacking
      delete dataInfo.dempOfsuppliesfinance
      delete dataInfo.dempOfsuppliespacking

      let newDataInfo = Object.assign(dempOfsuppliesfinance, dempOfsuppliespacking, dataInfo)
      for (let key in newDataInfo) {
        this.sendDataInfo[key] = newDataInfo[key]
      }
      console.log(this.sendDataInfo)
      console.log('newDataInfo', newDataInfo)

      return true
    },
    //取消
    initActionBox() {
      this.dataActionBox.showStatus = false
      this.init()
    },

    //确认新增
    async sendDataAction() {
      if (this.sendDataInfo.osmName == '') {
        this.$message({
          message: '请填写名称',
          type: 'error'
        });
        return false
      }
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addOfficeSupplies(this.sendDataInfo)
      } else {
        var dataInfo = this.returnData.list[this.selectedDataIndex]
        let sendData = this.sendDataInfo;

        sendData.osmModifier = this.$store.getters.getUserInfo.depId
        sendData.osmId = dataInfo.osmId
        sendData.osfId = dataInfo.dempOfsuppliesfinance.osfId
        sendData.ospId = dataInfo.dempOfsuppliespacking.ospId
        var responseData = await this.$http.editOfficeSupplies(sendData)
      }
      if (responseData.status == 200) {
        this.dataActionBox.showStatus = false
        // this.$refs["sendDataInfo"].resetFields();
        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        console.log(this.dataActionBox.actionType);
        if (this.dataActionBox.actionType == 0) {
          this.setDataPageNumber(1)
        } else {
          this.getDataList()
        }

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.openActionBox(actionData.actionType)
          break;
        case 1:
          this.openActionBox(actionData.actionType)
          break;
        case 2:
          this.delDataAction()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 删除数据
    delDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      if (!dataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: [dataInfo.osmId]
        }
        let responseData = await this.$http.delOfficeSuppliesList(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      }).catch(() => { });

    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = ''
      }
      this.sendDataInfo.osmCreater = this.$store.getters.getUserInfo.opmId
      this.dataActionBox.actionType = 0
      this.showTabs = '办公用品表单'
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 修改信息
    toEditPage(dataInfo) {
      sessionStorage.setItem('setOfficesuppliesInfo', JSON.stringify(dataInfo))
      this.$common.pageJump('/editOfficeSupplies')
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },

    //打开操作页面
    openActionBox(cate) {
      this.filterMainField()
      // this.init()
      if (cate == 0) {
        this.dataActionBox.boxTitle = '新增信息'
      } else {
        this.dataActionBox.boxTitle = '编辑信息'
        if (this.getDataDateils() == false) {
          return false
        }
      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getOfficeSuppliesList(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 获取页面数据列表
    async getPageInfo() {
      var ss = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({
        ids: [ss.jurId]
      })
      console.log(responseData);
      if (responseData.status == 200) {
        this.pageShowData = responseData.result
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.formDataList = this.pageShowData.jurFormVoList
        this.getButtonList()
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
//获得状态
    getIsGsp(str, val) {
      try {
        if (str.indexOf('[') === -1) return val
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr ? newStr : val
      } catch (ex) {
        return val
      }
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
        }
      })
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()


  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

/* .el-tabs--border-card_new {
        height: 85vh;
    } */

.page_form_box .el-row {
  display: flex;
  flex-wrap: wrap;
}

.el-form-item {
  margin-bottom: 10px;
}

v::deep .el-form-item__content {
  width: 212px;
}
</style>